import React, { useState, useContext, useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import moduleConfig from "./moduleConfig";
import { Store as toast } from "react-notifications-component";
import { updateInitialState, updateReducer } from "./reducers/updateReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import { isEmpty } from "../../../helpers/CommonHelper";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSRichTextEditor from "../../UI/forms/CMSRichTextEditor";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";

const PartnerUpdate = () => {
  const [updateState, updateDispatch] = useReducer(
    updateReducer,
    updateInitialState
  );
  const [formInitialValues, setFormInitialValues] = useState({});

  console.log(updateState);

  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let { id } = useParams();
  let navigate = useNavigate();

  let breadcrumbs = {
    listing: {
      label: moduleConfig.title,
      url: `/${moduleConfig.url}`,
    },
    details: {
      label: "Details",
      url: `/${moduleConfig.url}/${id}`,
    },
    update: {
      label: "Update",
    },
  };

  const onSubmit = async (data) => {
    //console.log(data);

    updateDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });
    try {
      const res = await axios.post(`${moduleConfig.url}/${id}`, data); //
      updateDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      navigate(`/${moduleConfig.url}`);
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} updated successfully.`,
        type: "success",
      });
    } catch (error) {
      //console.log(error.message);
      const status = error.response ? error.response.status : 500;
      const errorMessage =
        status === 400 ? error.response.data.errorMessage : error.message;
      console.log(errorMessage);

      updateDispatch({
        type: "FORM_SUBMISSION_FAILURE",
        payload: errorMessage,
      });
      setTimeout(() => {
        updateDispatch({
          type: "FORM_INITIAL_STATE",
        });
      }, 5000);
    }
  };

  const loadItem = async () => {
    if (id) {
      updateDispatch({
        type: "FETCH_REQUEST",
      });

      try {
        const res = await axios.get(`${moduleConfig.url}/${id}`); //
        updateDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        updateDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    //console.log("useEffect called for [id]")
    loadItem();

    setBreadcrumb([
      breadcrumbs.listing,
      breadcrumbs.details,
      breadcrumbs.update,
    ]);
  }, [id]);
  useEffect(() => {
    if (updateState.data.item && updateState.data.item._id) {
      //if (moduleConfig.fields && moduleConfig.fields.length > 0) {

      // let formFieldsWithFetchData = {}
      // moduleConfig.fields.map((field, index) => {

      //     formFieldsWithFetchData[field.fieldName] = updateState.data.item[field.fieldName]
      // })
      // console.log("Here =>>>>>>>>>>>>>>", formFieldsWithFetchData)
      setFormInitialValues(updateState.data.item);

      //};
    }
  }, [updateState.data]);

  let logoImageRequirement = {
    dimension: {
      width: 1200,
      height: 500,
    },
    allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
    size: 1024 * 1024 * 2,
  };
  let promoBannerRequirement = {
    dimension: {
      width: 500,
      height: 500,
    },
    allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
    size: 1024 * 1024 * 2,
  };
  let bannerImageRequirement = {
    dimension: {
      width: 1200,
      height: 630,
    },
    allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
    size: 1024 * 1024 * 3,
  };

  return (
    <DashboardLayout>
      {updateState.status === "fetching" && updateState.isLoading && (
        <ContainerLoading />
      )}
      {updateState.error && updateState.status === "fetchFailed" ? (
        <BlockErrorMessage error={updateState.error} />
      ) : (
        <>
          <ModuleHeader
            moduleTitle={`Update ${moduleConfig.singleItemTitle}`}
            moduleUrl={moduleConfig.url}
          ></ModuleHeader>

          {Object.keys(formInitialValues).length > 0 &&
            updateState.data &&
            updateState.data.item &&
            !isEmpty(updateState.data.item._id) && (
              <section className="content">
                <Card>
                  <Card.Body>
                    {updateState.isLoading && (
                      <div class="overlay position-absolute containerLoading">
                        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{ ...formInitialValues, isPromoted: formInitialValues.isPromoted === "1" ? true : false }}
                      validationSchema={yup.object({
                        title: yup.string().nullable().when("logo", {
                          is: (logo) => !logo,
                          then: yup.string().required("Title or logo is required."),
                        }),
                        logo: yup
                          .mixed()
                          .imageTypeCheck(logoImageRequirement.allowedExtensions)
                          .imageSizeCheck(logoImageRequirement.size),

                        banner: yup
                          .mixed()
                          .imageTypeCheck(bannerImageRequirement.allowedExtensions)
                          .imageSizeCheck(bannerImageRequirement.size)
                          .imageDimensionCheck(bannerImageRequirement.dimension),
                        promotionBanner: yup
                          .mixed()
                          .imageTypeCheck(promoBannerRequirement.allowedExtensions)
                          .imageSizeCheck(promoBannerRequirement.size)
                          .imageExactDimensionCheck(promoBannerRequirement.dimension).when("isPromoted", {
                            is: (isPromoted) => isPromoted === true,
                            then: yup
                              .mixed()
                              .imageTypeCheck(promoBannerRequirement.allowedExtensions)
                              .imageSizeCheck(promoBannerRequirement.size)
                              .imageExactDimensionCheck(promoBannerRequirement.dimension).required("Promotional banner is required."),
                          }),
                        isPromoted: yup.boolean(),
                        phone: yup.string(),
                        email: yup.string().email('invalid email'),
                        contactUsMessage: yup.string(),
                        websiteButtonText: yup.string(),
                        website: yup.string().url(),
                        heading1: yup.string(),
                        content1: yup.string().required("Required"),

                        heading2: yup.string(),
                        content2: yup.string(),

                        heading3: yup.string(),
                        content3: yup.string(),
                        promotionMessage: yup.string().max(60),
                        heading4: yup.string(),
                        content4: yup.string(),

                        heading5: yup.string(),
                        content5: yup.string(),

                        numberOfDaysToShow: yup.number().when("isPromoted", {
                          is: (isPromoted) => isPromoted === true,
                          then: yup.number().required("Required."),
                        }),
                        numberOfTimesToShowInADay: yup.number().when("isPromoted", {
                          is: (isPromoted) => isPromoted === true,
                          then: yup.number().required("Required."),
                        }),

                        sortOrder: yup.number().required("Required"),
                        status: yup.string().required("Required"),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values) => {
                        if (values.isPromoted === true) {
                          values.isPromoted = "1"
                        }
                        if (values.isPromoted === false) {
                          values.isPromoted = "0"
                          values.promotionBanner = ''
                          values.promotionMessage = ''
                        }
                        const formData = new FormData();
                        for (let name in values) {
                          if (Array.isArray(values[name])) {
                            formData.append(name, JSON.stringify(values[name]));
                          } else {
                            formData.append(name, values[name]);
                          }
                        }

                        onSubmit(formData);
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {/* {console.log(form.errors)} */}
                          {updateState.error && (
                            <FormErrorMessage error={updateState.error} />
                          )}

                          <CMSFormInput name="title" label="Title" required={false} form={form} />

                          <CMSFormImageWithCrop
                            label="Logo"
                            name="logo"
                            required={false}
                            form={form}
                            aspect={1 / 1}
                            outputSize={logoImageRequirement.dimension}
                          />

                          <CMSFormImageWithCrop
                            label="Banner"
                            name="banner"
                            required={false}
                            form={form}
                            aspect={16 / 9}
                            outputSize={bannerImageRequirement.dimension}
                          />

                          <CMSFormInput name="heading1" label="Short Description" required={false} form={form} />

                          <CMSFormRichText name="content1" label="Description" form={form} required={true} />

                          <CMSFormInput name="contactUsMessage" label="Contact Us Section Heading" required={false} form={form} />

                          <CMSFormInput
                            name="phone"
                            label="Phone"
                            form={form}
                          />
                          <CMSFormInput name="email" label="Email" required={false} form={form} />

                          <CMSFormInput name="website" label="Website" type="url" required={false} form={form} />


                          <CMSFormInput name="websiteButtonText" label="Website Button Text" required={false} form={form} />




                          {/* <CMSFormInput name="heading2" label="Heading 2" required={false} form={form} />

                          <CMSFormRichText name="content2" label="Content 2" form={form} />

                          <CMSFormInput name="heading3" label="Heading 3" required={false} form={form} />

                          <CMSFormRichText name="content3" label="Content 3" form={form} /> */}
                          <Row className="m-0 p-0 mt-2">
                            <Col className="m-0 mb-3">
                              <input
                                className="selectAll"
                                type="checkbox"
                                name="isPromoted"
                                id="isPromoted"
                                onChange={(e) => form.setFieldValue('isPromoted', e.target.checked)}
                                checked={form.values.isPromoted}
                              />
                              <label
                                for="isPromoted"
                                className="m-0 p-0 ml-2"
                              >
                                Include Promotional Banner
                              </label>
                            </Col>
                          </Row>
                          {form.values.isPromoted === true && <>
                            <CMSFormImageWithCrop
                              label="Promotion Banner"
                              name="promotionBanner"
                              form={form}
                              aspect={500 / 500}
                              outputSize={promoBannerRequirement.dimension}
                            />
                            <CMSFormInput name="promotionMessage" label="Promotion Message" required={false} form={form} />
                            <CMSFormInput type="number" name="numberOfDaysToShow" label="Number Of Days To Show" required={true} form={form} />
                            <CMSFormInput type="number" name="numberOfTimesToShowInADay" label="Number Of Times To Show In A Day" required={true} form={form} />
                          </>}


                          {/* <CMSFormInput name="heading4" label="Heading 4" required={false} form={form} />

                                                <CMSRichTextEditor name="content4" label="Content 4" form={form} />

                                                <CMSFormInput name="heading5" label="Heading 5" required={false} form={form} />

                                                <CMSRichTextEditor name="content5" label="Content 5" form={form} /> */}


                          <CMSFormInput type="number" name="sortOrder" label="Sort Order" required={false} form={form} />


                          <CMSFormSelect name="status" label="Status" required={true} form={form} options={[{ label: "Select Status...", value: "" }, { label: "Enabled", value: "1" }, { label: "Disabled", value: "0" }]} />



                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            )}
        </>
      )}
    </DashboardLayout>
  );
};
export default PartnerUpdate;
